/** ファイル名の最大文字数（拡張子含まず） */
export const FILE_NAME_MAX_LENGTH = 100;

/** ファイル名に使用できない文字 */
export const INVALID_FILE_NAME_CHARS = /[/\\:*?"<>|]/;

/**
 * ファイル名から拡張子を分離する
 * @param fileName - ファイル名（例: 'sample.csv'）
 * @returns base: 拡張子なしのベース名, ext: 拡張子（ドット付き、例: '.csv'）
 */
export const splitFileName = (fileName: string): { base: string; ext: string } => {
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex <= 0) {
    return { base: fileName, ext: '' };
  }
  return {
    base: fileName.slice(0, lastDotIndex),
    ext: fileName.slice(lastDotIndex),
  };
};

/**
 * ファイル名のバリデーション
 * @param value - 検証対象のファイル名（拡張子含まず）
 * @returns エラーメッセージ。エラーがなければ undefined
 */
export const validateFileName = (value: string): string | undefined => {
  const trimmed = value.trim();
  if (trimmed === '') return 'ファイル名を入力してください';
  if (trimmed.length > FILE_NAME_MAX_LENGTH) {
    return `${FILE_NAME_MAX_LENGTH}文字以内で入力してください`;
  }
  if (INVALID_FILE_NAME_CHARS.test(trimmed)) {
    return '使用できない文字が含まれています（/ \\ : * ? " < > |）';
  }
  return undefined;
};
